// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Share: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 42" enableBackground="new 0 0 38 42" xmlSpace="preserve">
<path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M31.5,29.5c-1.58,0-3,0.62-4.08,1.6l-14.85-8.65c0.1-0.48,0.19-0.96,0.19-1.46
	s-0.08-0.98-0.19-1.46l14.69-8.56c1.12,1.04,2.6,1.69,4.25,1.69c3.46,0,6.25-2.79,6.25-6.25s-2.79-6.25-6.25-6.25
	s-6.25,2.79-6.25,6.25c0,0.5,0.08,0.98,0.19,1.46l-14.69,8.56c-1.12-1.04-2.6-1.69-4.25-1.69c-3.46,0-6.25,2.79-6.25,6.25
	c0,3.46,2.79,6.25,6.25,6.25c1.65,0,3.12-0.65,4.25-1.69l14.83,8.67c-0.1,0.44-0.17,0.9-0.17,1.35c0,3.35,2.73,6.08,6.08,6.08
	s6.08-2.73,6.08-6.08C37.58,32.23,34.85,29.5,31.5,29.5z"/>
</svg>;
};

export default React.memo(Share);
